module.exports = __webpack_public_path__ + "static/media/12.dbd07341.jpeg";